module.exports = __webpack_public_path__ + "static/media/DC_F_Fashion_Sempione.8996796c.png";